import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import {
  AppRemixIcon,
  AppDatePicker,
  AppInput,
  AppMultiSelect,
  AppSingleSelect,
  AppCheckbox,
  AppNotificationAlert,
} from "@/layout/AppComponents";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { Formik } from "formik";
import Moment from "moment";
import { UnmountClosed } from "react-collapse/lib/UnmountClosed";
import styled from "styled-components";
import ReactDOMServer from "react-dom/server";
import * as currentPageAction from "../../../../../../store/actions/currentPageAction";
import CategorySelect from "../../../../../components/form/Selects/CategorySelect";
import ResponsibleSelect from "../../../../../components/form/Selects/ResponsibleSelect";
import SelectCategoryGroups from "../../../../../components/form/Selects/SelectCategoryGroups";
import UserSelectStates from "../../../../../components/form/Selects/UserSelectStates";
import Translator from "../../../../../components/helpers/Translator";
import NoteSelect from "../../../../../components/form/Selects/NoteSelect";
import colors from "../../../../../../constants/colors";
import { axiosPath, path } from "../../../../../../routing/helpers/router";
import { getGclFilterInitialValues } from "../../../../../../minions/forms";
import AuxSidebar from "../../../../../Sidebar/AuxSidebar";
import SelectLayout from "../../../../../components/form/Selects/SelectLayout";
import ObligationGroupSelect from "../../../../../components/form/Selects/ObligationGroupSelect";
import UserSelect from "../../../../../components/form/Selects/UserSelect";
import EvidenceTypeSelect from "../../../../../components/form/Selects/EvidenceTypeSelect";
import useIsMounted from "../../../../../components/hooks/useIsMounted";
import ClassifiedPlantSelect from "../../../../../components/form/Selects/ClassifiedPlantSelect";
import ObligationAssociationSelect from "../../../../../components/form/Selects/ObligationAssociationSelect";
import _ from "lodash";

const FilterSidebarBlock = () => {
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const navigate = useNavigate();
  const { moduleBridgeHex, plantHex, filtersHex } = useParams();
  const clientID = useSelector((state) => state.auth?.user?.client?.id);
  const auxSidebar = useSelector(
    (state) => state.currentPage?.auxSidebar?.opened,
  );
  const filters = useSelector((state) => state.currentPage?.filters);
  const filterPermissions = useSelector(
    (state) =>
      state.module[moduleBridgeHex]?.permissions?.gcl?.module?.plant?.filters,
  );
  const filterIsCorporatePermission = useSelector(
    (state) =>
      state.module[moduleBridgeHex]?.permissions?.global?.corporateObligations,
  );
  const layout = useSelector(
    (state) => state.currentPage?.options?.clientLayout,
  );
  const plantObligationTags = useSelector(
    (state) => state.currentPage?.options?.plantObligationTags,
  );
  const permissions = useSelector(
    (state) => state.module[moduleBridgeHex]?.permissions,
  );
  const plantLocations = useSelector(
    (state) => state.currentPage?.options?.plantLocations,
  );
  const hasObligationGroups = useSelector(
    (state) => state.currentPage?.options?.plantLocations,
  );
  const [openOnce, setOpenOnce] = useState(true);
  const [dateFilters, setDateFilters] = useState(false);
  const [fieldFilters, setFieldFilters] = useState(false);
  const [textFilters, setTextFilters] = useState(false);
  const [correctiveActionsFilters, setCorrectiveActionsFilters] =
    useState(false);
  const [textFilterTypeOptions, setTextFilterTypeOptions] = useState(null);
  const [plantObligationTagOptions] = useState([
    { label: "Si", value: "1" },
    { label: "No", value: "0" },
  ]);
  const [favouriteObligationsOptions] = useState([
    {
      label: ReactDOMServer.renderToString(
        <Translator
          file="module-legalCompliance"
          name="show.only.mark.favourite"
        />,
      ),
      value: 1,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator
          file="module-legalCompliance"
          name="show.only.mark.no.favourite"
        />,
      ),
      value: 2,
    },
  ]);
  const [probSevOptions] = useState([
    {
      label: ReactDOMServer.renderToString(
        <Translator file="filter" name="filter.probability.0" />,
      ),
      value: 0,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator file="filter" name="filter.probability.1" />,
      ),
      value: 1,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator file="filter" name="filter.probability.2" />,
      ),
      value: 2,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator file="filter" name="filter.probability.3" />,
      ),
      value: 3,
    },
  ]);
  const [riskOptions] = useState([
    {
      label: ReactDOMServer.renderToString(
        <Translator file="filter" name="filter.probability.0.m" />,
      ),
      value: 0,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator file="filter" name="filter.probability.1.m" />,
      ),
      value: 1,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator file="filter" name="filter.probability.2.m" />,
      ),
      value: 2,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator file="filter" name="filter.probability.3.m" />,
      ),
      value: 3,
    },
  ]);
  const [nextDateOptions] = useState([
    {
      label: ReactDOMServer.renderToString(
        <Translator
          file="module-legalCompliance"
          name="module.lc.nextDate-no"
        />,
      ),
      value: 0,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator
          file="module-legalCompliance"
          name="module.lc.nextDate-yes"
        />,
      ),
      value: 1,
    },
  ]);

  const [noYesOptions] = useState([
    {
      label: ReactDOMServer.renderToString(
        <Translator file="module-legalCompliance" name="no" />,
      ),
      value: 0,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator file="module-legalCompliance" name="yes" />,
      ),
      value: 1,
    },
  ]);

  const [correctiveActionsTasks] = useState([
    {
      label: ReactDOMServer.renderToString(
        <Translator
          file="module-legalCompliance"
          name="m-gcl-assigned.action.plan"
        />,
      ),
      value: 1,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator
          file="module-legalCompliance"
          name="m-gcl-open.action.plan"
        />,
      ),
      value: 2,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator
          file="module-legalCompliance"
          name="m-gcl-no.assigned.action.plan"
        />,
      ),
      value: 3,
    },
  ]);

  const handleTextFiltersTypeOptions = () => {
    const options = [];

    if (filterPermissions?.textFilters?.obligation?.obligation)
      options.push({
        value: "obligationText",
        label: <Translator file="filter" name="filter.text.field.ob" />,
      });
    if (filterPermissions?.textFilters?.obligation?.evidence)
      options.push({
        value: "obligationEvidence",
        label: <Translator file="filter" name="filter.text.field.e" />,
      });
    if (filterPermissions?.textFilters?.obligation?.nextDate)
      options.push({
        value: "obligationNextDate",
        label: <Translator file="filter" name="filter.text.field.p" />,
      });
    if (filterPermissions?.textFilters?.law?.title)
      options.push({
        value: "lawTitle",
        label: <Translator file="filter" name="filter.text.field.lt" />,
      });
    if (filterPermissions?.textFilters?.law?.modification)
      options.push({
        value: "lawModification",
        label: <Translator file="filter" name="filter.text.field.lm" />,
      });
    if (filterPermissions?.textFilters?.article?.name)
      options.push({
        value: "lawArticleName",
        label: <Translator file="filter" name="filter.text.field.la" />,
      });

    setTextFilterTypeOptions(options);
  };

  useEffect(() => {
    if (filterPermissions) {
      handleTextFiltersTypeOptions();

      if (filtersHex !== "0") {
        getFilters();
      } else {
        dispatch(
          currentPageAction.change(
            "filters",
            getGclFilterInitialValues(filterPermissions),
          ),
        );
      }
    }
  }, [filterPermissions, filtersHex]);

  const handleAuxSidebar = () => {
    if (!openOnce) setOpenOnce(true);
    if (auxSidebar !== "filters")
      dispatch(currentPageAction.change("auxSidebar", { opened: "filters" }));
    else dispatch(currentPageAction.change("auxSidebar", { opened: null }));
  };

  const goToEvaluation = (hexCode) =>
    navigate(
      path({
        name: "user_module_legalCompliance_evaluation",
        params: {
          moduleBridgeHex,
          plantHex,
          page: 1,
          filtersHex: hexCode,
        },
      }),
    );

  // > GENERATE FILTER HEX CODE
  const generateFilterHexCode = async (values, { setSubmitting }) => {
    await axios
      .post(
        axiosPath(
          "api_r_user_module_legalCompliance_evaluation_generateFilterHexCode",
        ),
        { moduleBridgeHex, filters: values },
      )
      .then(({ data }) => {
        setSubmitting(false);
        goToEvaluation(data.hexCode);
        dispatch(currentPageAction.change("auxSidebar", { opened: null }));
      })
      .catch(() => {
        AppNotificationAlert({
          title: "Error",
          message: "error",
          type: "danger",
          position: "top-right",
          duration: 3000,
        });
      });
  };
  // < GENERATE FILTER HEX CODE

  // > FILTERS
  const getFilters = async () => {
    await axios
      .post(
        axiosPath("api_r_user_module_legalCompliance_evaluation_getFilters"),
        { moduleBridgeHex, filtersHex },
      )
      .then(({ data }) => {
        if (isMounted.current) {
          dispatch(currentPageAction.change("filters", data));
        }
      });
  };

  const removeFilters = (resetForm) => {
    resetForm();
    goToEvaluation(0);
  };
  // < FILTERS

  const handleSelectClassifiedPlant = useCallback(
    async (values, setFieldValue, option) => {
      const prev = values.classifiedPlants ?? [];
      const selected = option ?? [];
      const getVal = (item) => {
        if (item == null) return null;
        if (typeof item === "number" || typeof item === "string")
          return String(item);
        if ("value" in item) return String(item.value);
        if ("id" in item) return String(item.id);
        return null;
      };
      const prevSet = new Set(prev.map(getVal));
      const nextSet = new Set(selected.map(getVal));
      const prevHadZero = prevSet.has("0");
      const nextHasZero = nextSet.has("0");
      const added = [...nextSet].filter((v) => !prevSet.has(v));
      let next;
      if (added.includes("0")) {
        const zeroItem = selected.find((x) => getVal(x) === "0");
        next = zeroItem !== undefined && zeroItem !== null ? [zeroItem] : [];
      } else if (prevHadZero && nextHasZero && added.length > 0) {
        next = selected.filter((x) => getVal(x) !== "0");
      } else {
        next = selected.filter((x) => getVal(x) !== "0");
      }

      setFieldValue("classifiedPlants", next);
    },
    [],
  );

  return (
    <>
      <li
        className={auxSidebar && auxSidebar === 'filters' ? 'active' : ''}
        onClick={() => handleAuxSidebar()}
      >
        <span className="sidebar-element">
          <AppRemixIcon icon="equalizer" className="sidebar-icon" />{' '}
          <span className="sb-title">
            <Translator file="module-legalCompliance" name="filtering" />
          </span>
        </span>
      </li>
      <AuxSidebar
        title={<Translator file="module-legalCompliance" name="filtering" />}
        isOpen={auxSidebar && auxSidebar === 'filters'}
        width="350px"
        position="right"
        onClose={() => handleAuxSidebar()}
      >
        {openOnce && (
          <>
            {filterPermissions && filters && (
              <Formik
                validateOnChange={false}
                validateOnBlur={false}
                enableReinitialize
                initialValues={filters}
                onSubmit={generateFilterHexCode}
              >
                {({
                  setFieldValue,
                  handleSubmit,
                  values,
                  isSubmitting,
                  resetForm,
                }) => (
                  <>
                    <div className="d-flex mt-3 mb-3">
                      <span
                        className="btn btn-info btn-block"
                        onClick={handleSubmit}
                        disabled={isSubmitting}
                      >
                        <Translator
                          file="module-legalCompliance"
                          name="filtering"
                        />
                      </span>
                      {filtersHex !== '0' && (
                        <span
                          title={ReactDOMServer.renderToString(
                            <Translator
                              file="module-legalCompliance"
                              name="delete.filters"
                            />,
                          )}
                          className="btn btn-outline-danger ml-1"
                          onClick={() => removeFilters(resetForm)}
                        >
                          <AppRemixIcon icon="delete-bin-6" />
                        </span>
                      )}
                    </div>
                    {filterPermissions.favouriteObligations && (
                      <AppSingleSelect
                        options={favouriteObligationsOptions}
                        title={ReactDOMServer.renderToString(
                          <Translator
                            file="module-legalCompliance"
                            name="favourite.obligations"
                          />,
                        )}
                        placeholder={ReactDOMServer.renderToString(
                          <Translator file="filter" name="filter.select" />,
                        )}
                        icon={<AppRemixIcon icon="star" />}
                        value={values?.favouriteObligations}
                        onChange={(opt) =>
                          setFieldValue('favouriteObligations', opt)
                        }
                        isClearable
                      />
                    )}
                    {filterPermissions.state && (
                      <>
                        <UserSelectStates
                          title={ReactDOMServer.renderToString(
                            <Translator
                              file="module-legalCompliance"
                              name="m-gcl-states"
                            />,
                          )}
                          placeholder={ReactDOMServer.renderToString(
                            <Translator
                              file="module-legalCompliance"
                              name="m-gcl-select.one.more.states"
                            />,
                          )}
                          onHandleChange={(opt) => setFieldValue('state', opt)}
                          value={values?.state}
                          isMulti
                          hasSelectOptions
                          elements={{
                            defaultStates: [0, 1, 2, 3, 4],
                            customStates: 'all',
                          }}
                        />
                        <AppSingleSelect
                          options={noYesOptions}
                          title={ReactDOMServer.renderToString(
                            <Translator
                              file="module-legalCompliance"
                              name="obsoletes"
                            />,
                          )}
                          icon={<AppRemixIcon icon="delete-bin" />}
                          value={values?.obsolete}
                          onChange={(v) => setFieldValue('obsolete', v)}
                        />
                      </>
                    )}
                    {plantObligationTags?.map((pot) => (
                      <AppSingleSelect
                        key={pot.id}
                        options={plantObligationTagOptions}
                        title={pot.name}
                        icon={<AppRemixIcon icon={pot.icon} />}
                        value={
                          values?.plantObligationTags?.[
                            `id-${pot.id.toString()}`
                          ]
                        }
                        onChange={(opt) =>
                          setFieldValue(
                            `plantObligationTags.id-${pot.id.toString()}`,
                            opt,
                          )
                        }
                        isClearable
                      />
                    ))}
                    {filterPermissions.date && (
                      <>
                        <FilterBlockTitle
                          onClick={() => setDateFilters(!dateFilters)}
                        >
                          <AppRemixIcon
                            icon={
                              dateFilters ? 'arrow-down-s' : 'arrow-right-s'
                            }
                            filled
                          />
                          <Translator
                            file="module-legalCompliance"
                            name="filters.by.date"
                          />
                        </FilterBlockTitle>
                        <UnmountClosed isOpened={dateFilters}>
                          <>
                            <div className="row">
                              <div className="col-lg-12">
                                <h6>
                                  <small>
                                    <Translator
                                      file="module-legalCompliance"
                                      name="filters.by.calendar.dates"
                                    />
                                  </small>
                                </h6>
                              </div>
                              <div className="col-lg-6">
                                <span
                                  className="btn btn-sm btn-outline-light btn-block"
                                  onClick={() => {
                                    setFieldValue('calendarFrom', '');
                                    setFieldValue(
                                      'calendarTo',
                                      Moment().subtract(1, 'days').unix(),
                                    );
                                  }}
                                >
                                  <Translator
                                    file="filter"
                                    name="filter.date.1"
                                  />
                                </span>
                                <span
                                  className="btn btn-sm btn-outline-light btn-block"
                                  onClick={() => {
                                    setFieldValue(
                                      'calendarFrom',
                                      Moment().unix(),
                                    );
                                    setFieldValue(
                                      'calendarTo',
                                      Moment().add(6, 'months').unix(),
                                    );
                                  }}
                                >
                                  <Translator
                                    file="filter"
                                    name="filter.date.3"
                                  />
                                </span>
                              </div>
                              <div className="col-lg-6">
                                <span
                                  className="btn btn-sm btn-outline-light btn-block"
                                  onClick={() => {
                                    setFieldValue(
                                      'calendarFrom',
                                      Moment().unix(),
                                    );
                                    setFieldValue(
                                      'calendarTo',
                                      Moment().add(3, 'months').unix(),
                                    );
                                  }}
                                >
                                  <Translator
                                    file="filter"
                                    name="filter.date.2"
                                  />
                                </span>

                                <span
                                  className="btn btn-sm btn-outline-light btn-block"
                                  onClick={() => {
                                    setFieldValue(
                                      'calendarFrom',
                                      Moment().unix(),
                                    );
                                    setFieldValue(
                                      'calendarTo',
                                      Moment().add(1, 'years').unix(),
                                    );
                                  }}
                                >
                                  <Translator
                                    file="filter"
                                    name="filter.date.4"
                                  />
                                </span>
                              </div>
                            </div>
                          </>
                          <div className="row">
                            <div className="col-lg-6">
                              <AppDatePicker
                                title={ReactDOMServer.renderToString(
                                  <Translator
                                    file="module-lawFinder"
                                    name="module.lf.filter.from"
                                  />,
                                )}
                                value={
                                  values.calendarFrom
                                    ? Moment.unix(values.calendarFrom).format(
                                        'DD/MM/YYYY',
                                      )
                                    : ''
                                }
                                onChange={(date) =>
                                  setFieldValue(
                                    'calendarFrom',
                                    date
                                      ? Moment(date, 'DD/MM/YYYY').unix()
                                      : '',
                                  )
                                }
                                placeholder="dd/mm/yyyy"
                                isClearable
                                showMonthDropdown
                                showYearDropdown
                              />
                            </div>
                            <div className="col-lg-6">
                              <AppDatePicker
                                title={ReactDOMServer.renderToString(
                                  <Translator
                                    file="module-lawFinder"
                                    name="module.lf.filter.to"
                                  />,
                                )}
                                value={
                                  values.calendarTo
                                    ? Moment.unix(values.calendarTo).format(
                                        'DD/MM/YYYY',
                                      )
                                    : ''
                                }
                                onChange={(date) =>
                                  setFieldValue(
                                    'calendarTo',
                                    date
                                      ? Moment(date, 'DD/MM/YYYY').unix()
                                      : '',
                                  )
                                }
                                placeholder="dd/mm/yyyy"
                                isClearable
                                showMonthDropdown
                                showYearDropdown
                              />
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-lg-12">
                              <hr />
                              <h6>
                                <small>
                                  <Translator
                                    file="module-legalCompliance"
                                    name="obligation.signup.modification"
                                  />
                                </small>
                              </h6>
                            </div>
                            <div className="col-lg-6">
                              <AppDatePicker
                                title={ReactDOMServer.renderToString(
                                  <Translator
                                    file="module-lawFinder"
                                    name="module.lf.filter.from"
                                  />,
                                )}
                                value={
                                  values.modificationFrom
                                    ? Moment.unix(
                                        values.modificationFrom,
                                      ).format('DD/MM/YYYY')
                                    : ''
                                }
                                onChange={(date) =>
                                  setFieldValue(
                                    'modificationFrom',
                                    date
                                      ? Moment(date, 'DD/MM/YYYY').unix()
                                      : '',
                                  )
                                }
                                placeholder="dd/mm/yyyy"
                                isClearable
                                showMonthDropdown
                                showYearDropdown
                              />
                            </div>
                            <div className="col-lg-6">
                              <AppDatePicker
                                title={ReactDOMServer.renderToString(
                                  <Translator
                                    file="module-lawFinder"
                                    name="module.lf.filter.to"
                                  />,
                                )}
                                value={
                                  values.modificationTo
                                    ? Moment.unix(values.modificationTo).format(
                                        'DD/MM/YYYY',
                                      )
                                    : ''
                                }
                                onChange={(date) =>
                                  setFieldValue(
                                    'modificationTo',
                                    date
                                      ? Moment(date, 'DD/MM/YYYY').unix()
                                      : '',
                                  )
                                }
                                placeholder="dd/mm/yyyy"
                                isClearable
                                showMonthDropdown
                                showYearDropdown
                              />
                            </div>
                          </div>
                          {filterPermissions.evidenceSearch?.date && (
                            <div className="row">
                              <div className="col-lg-12">
                                <hr />
                                <h6>
                                  <small>
                                    <Translator
                                      file="module-legalCompliance"
                                      name="m.gcl.evidence-date"
                                    />
                                  </small>
                                </h6>
                              </div>
                              <div className="col-lg-6">
                                <AppDatePicker
                                  title={ReactDOMServer.renderToString(
                                    <Translator
                                      file="module-legalCompliance"
                                      name="module.lc.from"
                                    />,
                                  )}
                                  value={
                                    values.evidenceSearchDateFrom
                                      ? Moment.unix(
                                          values.evidenceSearchDateFrom,
                                        ).format('DD/MM/YYYY')
                                      : ''
                                  }
                                  onChange={(date) =>
                                    setFieldValue(
                                      'evidenceSearchDateFrom',
                                      date
                                        ? Moment(date, 'DD/MM/YYYY').unix()
                                        : '',
                                    )
                                  }
                                  placeholder="dd/mm/yyyy"
                                  isClearable
                                  showMonthDropdown
                                  showYearDropdown
                                />
                              </div>
                              <div className="col-lg-6">
                                <AppDatePicker
                                  title={ReactDOMServer.renderToString(
                                    <Translator
                                      file="module-legalCompliance"
                                      name="module.lc.to"
                                    />,
                                  )}
                                  value={
                                    values.evidenceSearchDateTo
                                      ? Moment.unix(
                                          values.evidenceSearchDateTo,
                                        ).format('DD/MM/YYYY')
                                      : ''
                                  }
                                  onChange={(date) =>
                                    setFieldValue(
                                      'evidenceSearchDateTo',
                                      date
                                        ? Moment(date, 'DD/MM/YYYY').unix()
                                        : '',
                                    )
                                  }
                                  placeholder="dd/mm/yyyy"
                                  isClearable
                                  showMonthDropdown
                                  showYearDropdown
                                />
                              </div>
                            </div>
                          )}
                        </UnmountClosed>
                      </>
                    )}
                    <FilterBlockTitle
                      onClick={() => setFieldFilters(!fieldFilters)}
                    >
                      <AppRemixIcon
                        icon={fieldFilters ? 'arrow-down-s' : 'arrow-right-s'}
                        filled
                      />
                      <Translator
                        file="module-legalCompliance"
                        name="filters.by.features"
                      />
                    </FilterBlockTitle>
                    <UnmountClosed isOpened={fieldFilters}>
                      <>
                        {filterPermissions.category && (
                          <CategorySelect
                            value={values.category || []}
                            onHandleChange={(opt) =>
                              setFieldValue('category', opt)
                            }
                            isMulti
                            hasSearchBox
                            hasSelectOptions
                          />
                        )}
                        {filterPermissions.layout && layout && (
                          <SelectLayout
                            value={values.layout || []}
                            onHandleChange={(opt) =>
                              setFieldValue('layout', opt)
                            }
                            isMulti
                            hasSearchBox
                            hasSelectOptions
                          />
                        )}
                        {filterPermissions.categoryGroups &&
                          permissions?.gcl?.module?.plant?.categoryGroups
                            ?.length > 0 && (
                            <SelectCategoryGroups
                              options={
                                permissions?.gcl?.module?.plant?.categoryGroups
                              }
                              value={values.categoryGroups || []}
                              onHandleChange={(opt) =>
                                setFieldValue('categoryGroups', opt)
                              }
                              isMulti
                              hasSearchBox
                              hasSelectOptions
                            />
                          )}
                        {filterPermissions.location && plantLocations && (
                          <AppMultiSelect
                            title={ReactDOMServer.renderToString(
                              <Translator
                                file="location"
                                name="location.title"
                              />,
                            )}
                            icon={<AppRemixIcon icon="earth" />}
                            value={values.location || []}
                            options={plantLocations}
                            onChange={(v) => setFieldValue('location', v)}
                            hasSearchBox
                            hasSelectOptions
                          />
                        )}
                        {filterPermissions.locationLaw && plantLocations && (
                          <AppMultiSelect
                            title={ReactDOMServer.renderToString(
                              <Translator
                                file="location"
                                name="location.law.title"
                              />,
                            )}
                            icon={<AppRemixIcon icon="earth" />}
                            value={values.locationLaw || []}
                            options={plantLocations}
                            onChange={(v) => setFieldValue('locationLaw', v)}
                            hasSearchBox
                            hasSelectOptions
                          />
                        )}
                        {filterPermissions.note && (
                          <NoteSelect
                            value={values.note || []}
                            onHandleChange={(opt) => setFieldValue('note', opt)}
                            isMulti
                            hasSearchBox
                            hasSelectOptions
                          />
                        )}
                        {filterPermissions.noteObligationAssociation && (
                          <ObligationAssociationSelect
                            value={values.noteObligationAssociation || []}
                            onHandleChange={(opt) =>
                              setFieldValue('noteObligationAssociation', opt)
                            }
                            isMulti
                            hasSearchBox
                            hasSelectOptions
                          />
                        )}
                        {filterPermissions.probability && (
                          <AppMultiSelect
                            options={probSevOptions || []}
                            title={ReactDOMServer.renderToString(
                              <Translator
                                file="filter"
                                name="filter.probability"
                              />,
                            )}
                            icon={<AppRemixIcon icon="numbers" />}
                            value={values?.probability || null}
                            onChange={(opt) =>
                              setFieldValue('probability', opt)
                            }
                            isMulti
                          />
                        )}
                        {filterPermissions.severity && (
                          <AppMultiSelect
                            options={probSevOptions || []}
                            title={ReactDOMServer.renderToString(
                              <Translator
                                file="filter"
                                name="filter.severity"
                              />,
                            )}
                            icon={<AppRemixIcon icon="numbers" />}
                            value={values?.severity || null}
                            onChange={(opt) => setFieldValue('severity', opt)}
                            isMulti
                          />
                        )}
                        {filterPermissions.risk && (
                          <AppMultiSelect
                            options={riskOptions || []}
                            title={ReactDOMServer.renderToString(
                              <Translator
                                file="module-legalCompliance"
                                name="module.lc.risk"
                              />,
                            )}
                            icon={<AppRemixIcon icon="numbers" />}
                            value={values.risk || []}
                            onChange={(opt) => setFieldValue('risk', opt)}
                            isMulti
                          />
                        )}
                        {filterPermissions.nextDate && (
                          <AppMultiSelect
                            options={nextDateOptions || []}
                            title={ReactDOMServer.renderToString(
                              <Translator
                                file="module-legalCompliance"
                                name="module.lc.nextDate"
                              />,
                            )}
                            icon={<AppRemixIcon icon="timer" />}
                            value={values.nextDate || []}
                            onChange={(opt) => setFieldValue('nextDate', opt)}
                            isMulti
                          />
                        )}
                        {filterPermissions.nextDateAcciona && (
                          <AppMultiSelect
                            options={nextDateOptions || []}
                            title={ReactDOMServer.renderToString(
                              <Translator
                                file="module-legalCompliance"
                                name="module.lc.nextDate"
                              />,
                            )}
                            icon={<AppRemixIcon icon="timer" />}
                            value={values.nextDateAcciona || []}
                            onChange={(opt) =>
                              setFieldValue('nextDateAcciona', opt)
                            }
                            isMulti
                          />
                        )}
                        {filterIsCorporatePermission && (
                          <AppSingleSelect
                            options={noYesOptions}
                            title={ReactDOMServer.renderToString(
                              <Translator
                                file="module-legalCompliance"
                                name="corporate.obligation"
                              />,
                            )}
                            icon={<AppRemixIcon icon="building-4" />}
                            value={values?.isCorporate}
                            onChange={(opt) =>
                              setFieldValue('isCorporate', opt)
                            }
                          />
                        )}
                        {
                          // Filtro ponderaciones Saica
                        }
                        {filterPermissions.ponderacionesObligations && (
                          <AppInput
                            icon={<AppRemixIcon icon="fingerprint" />}
                            title={
                              <Translator
                                file="module-legalCompliance"
                                name="legalCompliance-filters.ponmeraciones"
                              />
                            }
                            placeholder={
                              <Translator
                                file="module-legalCompliance"
                                name="legalCompliance-filters.ponmeraciones"
                              />
                            }
                            value={values?.ponderacionesObligations ?? ''}
                            onChange={(value) =>
                              setFieldValue(
                                'ponderacionesObligations',
                                value.replace(/[^0-9a-fA-F,.]/g, ''),
                              )
                            }
                            isClearable
                          />
                        )}
                        {filterPermissions.responsible && (
                          <ResponsibleSelect
                            value={values.responsible || []}
                            onHandleChange={(opt) =>
                              setFieldValue('responsible', opt)
                            }
                            apiCall="api_r_user_module_legalCompliance_responsible_getResponsibles"
                            hasSearchBox
                            isClearable
                            hasNoResponsibleOption
                          />
                        )}
                        {filterPermissions.obligationGroups &&
                          hasObligationGroups && (
                            <ObligationGroupSelect
                              value={values.obligationGroups || []}
                              onHandleChange={(opt) =>
                                setFieldValue('obligationGroups', opt)
                              }
                              hasSearchBox
                              isClearable
                            />
                          )}
                        {permissions?.gcl?.module?.submodules?.correctiveActions
                          ?.supervisionSystem &&
                          hasObligationGroups && (
                            <>
                              <UserSelect
                                title={ReactDOMServer.renderToString(
                                  <Translator
                                    file="module-legalCompliance"
                                    name="m-gcl-supervisors"
                                  />,
                                )}
                                clientID={clientID}
                                plantHex={plantHex}
                                value={values.supervisors || []}
                                onChange={(opt) =>
                                  setFieldValue('supervisors', opt)
                                }
                                hasSearchBox
                                hasSelectOptions
                              />
                              <UserSelect
                                title={ReactDOMServer.renderToString(
                                  <Translator
                                    file="module-legalCompliance"
                                    name="m-gcl-owners"
                                  />,
                                )}
                                clientID={clientID}
                                plantHex={plantHex}
                                value={values.owners || []}
                                onChange={(opt) => setFieldValue('owners', opt)}
                                hasSearchBox
                                hasSelectOptions
                              />
                            </>
                          )}

                        {filterPermissions.obligationEvidence && (
                          <EvidenceTypeSelect
                            value={values.obligationEvidence || []}
                            onHandleChange={(opt) =>
                              setFieldValue('obligationEvidence', opt)
                            }
                            isClearable
                          />
                        )}
                        {filterPermissions.evidenceSearch && (
                          <AppSingleSelect
                            options={[
                              {
                                value: true,
                                label: ReactDOMServer.renderToString(
                                  <Translator
                                    file="module-legalCompliance"
                                    name="m.gcl.with-evidence"
                                  />,
                                ),
                              },
                              {
                                value: false,
                                label: ReactDOMServer.renderToString(
                                  <Translator
                                    file="module-legalCompliance"
                                    name="m-gcl-without.evidence"
                                  />,
                                ),
                              },
                            ]}
                            title={ReactDOMServer.renderToString(
                              <Translator
                                file="module-legalCompliance"
                                name="m-glc-obligation.evidence"
                              />,
                            )}
                            icon={<AppRemixIcon icon="archive-stack" />}
                            value={values?.evidenceSearch}
                            onChange={(v) => setFieldValue('evidenceSearch', v)}
                            isClearable
                          />
                        )}
                        {filterPermissions.evidenceSearch?.hasFile && (
                          <AppSingleSelect
                            options={[
                              {
                                value: true,
                                label: ReactDOMServer.renderToString(
                                  <Translator
                                    file="module-legalCompliance"
                                    name="m-gcl-evidence.with.file"
                                  />,
                                ),
                              },
                              {
                                value: false,
                                label: ReactDOMServer.renderToString(
                                  <Translator
                                    file="module-legalCompliance"
                                    name="m-gcl-evidence.without.file"
                                  />,
                                ),
                              },
                            ]}
                            title={ReactDOMServer.renderToString(
                              <Translator
                                file="module-legalCompliance"
                                name="m-gcl-evidence.file"
                              />,
                            )}
                            icon={<AppRemixIcon icon="file-text" />}
                            value={values?.evidenceSearchHasFile}
                            onChange={(v) =>
                              setFieldValue('evidenceSearchHasFile', v)
                            }
                            isClearable
                          />
                        )}

                        {filterPermissions.classifiedPlants && (
                          <ClassifiedPlantSelect
                            value={values.classifiedPlants || []}
                            onChange={(option) =>
                              handleSelectClassifiedPlant(
                                values,
                                setFieldValue,
                                option,
                              )
                            }
                            isMulti
                            className="mt-2"
                            isClearable
                            onlyIcpe
                            plantHex={plantHex}
                            addNoClassifiedPlantsOption
                          />
                        )}
                        {filterPermissions.priority && (
                          <AppMultiSelect
                            title={ReactDOMServer.renderToString(
                              <Translator
                                file="module-legalCompliance"
                                name="m.glc.priority"
                              />,
                            )}
                            icon={
                              <AppRemixIcon icon="list-check-3" noVariants />
                            }
                            options={[
                              {
                                value: 0,
                                label: ReactDOMServer.renderToString(
                                  <Translator
                                    file="module-legalCompliance"
                                    name="m.glc.no-priority"
                                  />,
                                ),
                              },
                              {
                                value: 1,
                                label: ReactDOMServer.renderToString(
                                  <Translator
                                    file="module-legalCompliance"
                                    name="m.glc.very-low"
                                  />,
                                ),
                              },
                              {
                                value: 2,
                                label: ReactDOMServer.renderToString(
                                  <Translator
                                    file="module-legalCompliance"
                                    name="acciona.penalty.risk.classification.low"
                                  />,
                                ),
                              },
                              {
                                value: 3,
                                label: ReactDOMServer.renderToString(
                                  <Translator
                                    file="module-legalCompliance"
                                    name="acciona.penalty.risk.classification.medium"
                                  />,
                                ),
                              },
                              {
                                value: 4,
                                label: ReactDOMServer.renderToString(
                                  <Translator
                                    file="module-legalCompliance"
                                    name="acciona.penalty.risk.classification.high"
                                  />,
                                ),
                              },
                              {
                                value: 5,
                                label: ReactDOMServer.renderToString(
                                  <Translator
                                    file="module-legalCompliance"
                                    name="m.glc.very-high"
                                  />,
                                ),
                              },
                            ]}
                            value={values.priority}
                            onChange={(opt) => {
                              setFieldValue('priority', opt);
                            }}
                          />
                        )}

                        {filterPermissions.id && (
                          <AppInput
                            title="IDs"
                            placeholder={
                              <Translator
                                file="module-legalCompliance"
                                name="split.by.commas"
                              />
                            }
                            icon={<AppRemixIcon icon="fingerprint" />}
                            value={values.id}
                            onChange={(opt) =>
                              setFieldValue(
                                'id',
                                /^([0-9]|,)*$/.test(opt) ? opt : values.id,
                              )
                            }
                            isClearable
                          />
                        )}
                        {filterPermissions.hex && (
                          <AppInput
                            title="CODE"
                            placeholder={
                              <Translator
                                file="module-legalCompliance"
                                name="split.by.commas"
                              />
                            }
                            icon={<AppRemixIcon icon="fingerprint" />}
                            value={values.hex}
                            onChange={(opt) =>
                              setFieldValue(
                                'hex',
                                opt.replace(/[^0-9a-fA-F,]/g, '').toUpperCase(),
                              )
                            }
                            isClearable
                          />
                        )}
                      </>
                    </UnmountClosed>
                    {filterPermissions.textFilters && (
                      <>
                        <FilterBlockTitle
                          onClick={() => setTextFilters(!textFilters)}
                        >
                          <AppRemixIcon
                            icon={
                              textFilters ? 'arrow-down-s' : 'arrow-right-s'
                            }
                            filled
                          />
                          <Translator
                            file="module-legalCompliance"
                            name="filters.by.text"
                          />
                        </FilterBlockTitle>
                        <UnmountClosed isOpened={textFilters}>
                          <>
                            <AppInput
                              title={
                                <Translator
                                  file="module-legalCompliance"
                                  name="text"
                                />
                              }
                              icon={<AppRemixIcon icon="file-text" />}
                              value={values.textFilter}
                              onChange={(opt) =>
                                setFieldValue('textFilter', opt)
                              }
                              isClearable
                            />
                            <AppMultiSelect
                              options={textFilterTypeOptions}
                              title={
                                <Translator
                                  file="module-legalCompliance"
                                  name="search.in"
                                />
                              }
                              icon={<AppRemixIcon icon="search" />}
                              value={values?.textFiltersTypes || []}
                              onChange={(opt) =>
                                setFieldValue('textFiltersTypes', opt)
                              }
                            />
                          </>
                        </UnmountClosed>
                      </>
                    )}
                    {(filterPermissions.correctiveActions
                      ?.correctiveActionsTasks ||
                      filterPermissions.correctiveActions
                        ?.correctiveActionsTasksOpenUpdates ||
                      filterPermissions.correctiveActions
                        ?.correctiveActionsTasksUpdatesAssignedToMe) && (
                      <>
                        <FilterBlockTitle
                          onClick={() =>
                            setCorrectiveActionsFilters(
                              !correctiveActionsFilters,
                            )
                          }
                        >
                          <AppRemixIcon
                            icon={
                              correctiveActionsFilters
                                ? 'arrow-down-s'
                                : 'arrow-right-s'
                            }
                            filled
                          />
                          <Translator
                            file="module-legalCompliance"
                            name="filters.by.action.plan"
                          />
                        </FilterBlockTitle>
                        <UnmountClosed isOpened={correctiveActionsFilters}>
                          {filterPermissions.correctiveActions
                            .correctiveActionsTasks && (
                            <AppSingleSelect
                              options={correctiveActionsTasks}
                              title={ReactDOMServer.renderToString(
                                <Translator
                                  file="module-legalCompliance"
                                  name="action.plan"
                                />,
                              )}
                              icon={<AppRemixIcon icon="search" />}
                              value={values?.correctiveActionsTasks || null}
                              onChange={(opt) =>
                                setFieldValue('correctiveActionsTasks', opt)
                              }
                              isClearable
                            />
                          )}
                          {filterPermissions.correctiveActions
                            .correctiveActionsTasksOpenUpdates && (
                            <AppCheckbox
                              onChange={(opt) =>
                                setFieldValue(
                                  'correctiveActionsTasksOpenUpdates',
                                  opt,
                                )
                              }
                              value={values?.correctiveActionsTasksOpenUpdates}
                            >
                              <Translator
                                file="module-legalCompliance"
                                name="m-gcl-action.plan.with.opened.actions"
                              />
                            </AppCheckbox>
                          )}
                          {filterPermissions.correctiveActions
                            .correctiveActionsTasksUpdatesAssignedToMe && (
                            <AppCheckbox
                              onChange={(opt) =>
                                setFieldValue(
                                  'correctiveActionsTasksUpdatesAssignedToMe',
                                  opt,
                                )
                              }
                              value={
                                values?.correctiveActionsTasksUpdatesAssignedToMe
                              }
                            >
                              <Translator
                                file="module-legalCompliance"
                                name="m-gcl-action.plan.with.my.responsibility.actions"
                              />
                            </AppCheckbox>
                          )}
                        </UnmountClosed>
                      </>
                    )}
                  </>
                )}
              </Formik>
            )}
          </>
        )}
      </AuxSidebar>
    </>
  );
};
export default FilterSidebarBlock;

const FilterBlockTitle = styled.div`
  color: ${colors.primary};
  font-size: 14px;
  margin-top: 10px;
  cursor: pointer;
`;
